import { useSelector } from "react-redux";
import { Trans, useTranslation } from "react-i18next";
import { HEADER } from "@/appConstants";

export default function GreetingSection() {
  const user = useSelector((state: any) => state.user);
  const firstname = (user && user.name && user.name.split(" ")[0]) || "";
  const { t } = useTranslation();
  return (
    <div className="ccwp_caselist_innerwrapper">
      <h3 className="motif-h3-default-bold">
        {t("pages.home.hello", { name: firstname })},
      </h3>
      <p className="motif-body2-default-light">
        <Trans
          i18nKey="pages.home.greetings"
          values={{ applicationHeading: HEADER.applicationNameInHeader }}
          components={{
            Email: <a href="mailto:CMS@ca.ey.com">CMS@ca.ey.com</a>,
            LearningMaterialsLink: (
              <a
                href="https://eycanada.sharepoint.com/sites/ClaimsManagementSystem-CMSPhase1-LearningMaterials/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FClaimsManagementSystem%2DCMSPhase1%2DLearningMaterials%2FShared%20Documents%2FVideos&p=true&ct=1754523360838&or=Teams%2DHL&ga=1&LOF=1"
                target="_blank"
                title={t("pages.home.learningMaterials")}
                rel="noopener noreferrer"
              />
            ),
          }}
        />
      </p>
    </div>
  );
}
